import { useEffect } from "react";
import { navigate, Route, routes, Switch, useRouteMatch } from "../../lib/urls";
import { Custom } from "./Custom";

export function Skills() {
  return (
    <Switch>
      <Route path={routes.skills.list}>
        <Custom />
      </Route>
      <Route path={routes.skills}>
        <RedirectToSkills />
      </Route>
    </Switch>
  );
}

function RedirectToSkills() {
  const [isList] = useRouteMatch(routes.skills.list);

  useEffect(() => {
    if (!isList) navigate(routes.skills.list, undefined, { replace: true });
  }, [isList]);

  return null;
}
